import { Component, HostListener, Input, NgZone } from '@angular/core';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { SessionRow } from '../../providers/sessions-provider';
import { SessionsSessionViewDialogComponent } from '../session-view-dialog/session-view-dialog';
import { Organization } from "../../../common/models/organization";
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TableHistogramChartComponent } from "../../../common/components/table-histogram-chart/table-histogram-chart";
import { DurationVerbosePipe } from "../../../common/pipes/duration-verbose";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sessions-session-preview',
  standalone: true,
  providers: [],
  styleUrls: ['./session-preview.scss'],
  imports: [
    TableHistogramChartComponent,
    DurationVerbosePipe,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './session-preview.html'
})
export class SessionsSessionPreviewComponent {
    @Input() public set sessionRow(sessionRow: SessionRow) {
        if (this._sessionRow != sessionRow) {
            this._sessionRow = sessionRow;
            this.duration = sessionRow.totalTime ??0;
        }
    }
    public get sessionRow() {
        return this._sessionRow;
    }
    @Input() public organization: Organization = {} as Organization;

    public duration = 0;
    private _sessionRow: SessionRow = {} as SessionRow;
    constructor(
        private _utils: UtilsProvider,
        private _dialog: MatDialog,
        private _ngZone: NgZone
    ) {

    }

    public ngAfterContentInit() {

    }

    @HostListener('click', ['$event'])
    public onClick(e: any): void {
        this._ngZone.run(() => {
            this._dialog.open(SessionsSessionViewDialogComponent, {
                data: {
                    sessionId: this.sessionRow.id,
                    organization: this.organization,
                    isEditable: true
                }
            });
        });
    }
}
